var _style, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D3317D;}\n\t.st1{fill:#C380A0;}\n\t.st2{fill:#C6A5B5;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 60,
    className: "st0",
    width: 30,
    height: 80
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "y",
    begin: "-0.2s",
    calcMode: "spline",
    dur: "1s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "18;30;30"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "height",
    begin: "-0.2s",
    calcMode: "spline",
    dur: "1s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "64;40;40"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 60,
    className: "st1",
    width: 30,
    height: 80
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "y",
    begin: "-0.1s",
    calcMode: "spline",
    dur: "1s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "20.999999999999996;30;30"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "height",
    begin: "-0.1s",
    calcMode: "spline",
    dur: "1s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "58.00000000000001;40;40"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 60,
    className: "st2",
    width: 30,
    height: 80
  }, /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "y",
    calcMode: "spline",
    dur: "1s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "20.999999999999996;30;30"
  }), /*#__PURE__*/React.createElement("animate", {
    accumulate: "none",
    additive: "replace",
    attributeName: "height",
    calcMode: "spline",
    dur: "1s",
    fill: "remove",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    restart: "always",
    values: "58.00000000000001;40;40"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalLoader);
export default __webpack_public_path__ + "static/media/globalLoader.7cb6d3fd09148b534016b6278d3770de.svg";
export { ForwardRef as ReactComponent };